import { Link } from "react-router-dom";
import { useBrand } from "../../lib/brand";

export default function Footer() {
  const brand = useBrand();
  return (
    <footer className="bg-navy border-t border-white/10 relative grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-7 h-7 bg-safety flex flex-col justify-center items-center gap-[3px]" aria-hidden="true">
              <span className="block w-3.5 h-[2px] bg-navy" />
              <span className="block w-2.5 h-[2px] bg-navy" />
              <span className="block w-1.5 h-[2px] bg-navy" />
            </span>
            <span className="font-display font-extrabold text-white">{brand.business_name}</span>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed">
            {brand.tagline}
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 mt-6">
            [WB-SYS // EST. FOR OPERATORS]
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Program</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/program" className="text-slate-300 hover:text-safety transition-colors">The Back Office Blueprint</Link></li>
            <li><Link to="/how-it-works" className="text-slate-300 hover:text-safety transition-colors">How It Works</Link></li>
            <li><Link to="/apply" className="text-slate-300 hover:text-safety transition-colors">Apply</Link></li>
            <li><Link to="/faq" className="text-slate-300 hover:text-safety transition-colors">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="text-slate-300 hover:text-safety transition-colors">About</Link></li>
            <li><Link to="/contact" className="text-slate-300 hover:text-safety transition-colors">Contact</Link></li>
            <li><Link to="/login" className="text-slate-300 hover:text-safety transition-colors">Member Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Legal</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/privacy" className="text-slate-300 hover:text-safety transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-slate-300 hover:text-safety transition-colors">Terms of Service</Link></li>
            <li><Link to="/refunds" className="text-slate-300 hover:text-safety transition-colors">Refund Policy</Link></li>
            <li><Link to="/program-agreement" className="text-slate-300 hover:text-safety transition-colors">Program Agreement</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2">
          <p className="text-slate-500 text-xs">© {new Date().getFullYear()} {brand.business_name}. All rights reserved.</p>
          <p className="font-mono text-[11px] text-slate-600 uppercase tracking-widest">Built for owner-operators</p>
        </div>
      </div>
    </footer>
  );
}
